module.exports = __webpack_public_path__ + "static/9abdb0c0f970e9080d2bd35e76ab757d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/macbook-content.jpg
// module id = 1184
// module chunks = 0